var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "gender form__field subWrapper" }, [
        _c("div", { staticClass: "form__field-radio" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.gender,
                expression: "form.gender",
              },
            ],
            attrs: {
              id: "woman",
              type: "radio",
              value: "Woman",
              name: "gender",
            },
            domProps: { checked: _vm._q(_vm.form.gender, "Woman") },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.form, "gender", "Woman")
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "label__woman", attrs: { for: "woman" } },
            [_vm._v(" " + _vm._s(_vm.$t("contactForm.gender.woman")))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.gender,
                expression: "form.gender",
              },
            ],
            attrs: { id: "man", type: "radio", value: "Man", name: "gender" },
            domProps: { checked: _vm._q(_vm.form.gender, "Man") },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.form, "gender", "Man")
              },
            },
          }),
          _vm._v(" "),
          _c("label", { staticClass: "label__man", attrs: { for: "man" } }, [
            _vm._v(" " + _vm._s(_vm.$t("contactForm.gender.man"))),
          ]),
        ]),
        _vm._v(" "),
        !_vm.$v.form.gender.required && _vm.$v.form.gender.$dirty
          ? _c("p", { staticClass: "error-alert" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("contactForm.error.required")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper subWrapper" }, [
        _c("div", [
          _c("div", { staticClass: "form__field form__field-text" }, [
            _vm.form.lastname
              ? _c("label", { attrs: { for: "lastname" } }, [
                  _vm._v(_vm._s(_vm.$t("contactForm.lastname"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.lastname,
                  expression: "form.lastname",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("contactForm.lastname"),
                name: "lastname",
              },
              domProps: { value: _vm.form.lastname },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "lastname", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          !_vm.$v.form.lastname.required && _vm.$v.form.lastname.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.lastnameRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.form.lastname.forbiddenCharactersAndDigit &&
          _vm.$v.form.lastname.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.lastnameValidRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "form__field form__field-text" }, [
            _vm.form.firstname
              ? _c("label", { attrs: { for: "firstname" } }, [
                  _vm._v(_vm._s(_vm.$t("contactForm.firstname"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.firstname,
                  expression: "form.firstname",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("contactForm.firstname"),
                name: "firstname",
              },
              domProps: { value: _vm.form.firstname },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "firstname", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          !_vm.$v.form.firstname.required && _vm.$v.form.firstname.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.firstnameRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.form.firstname.forbiddenCharactersAndDigit &&
          _vm.$v.form.firstname.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.firstnameValidRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "form__field form__field-text" }, [
            _vm.form.email
              ? _c("label", { attrs: { for: "email" } }, [
                  _vm._v(_vm._s(_vm.$t("contactForm.email"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.email,
                  expression: "form.email",
                },
              ],
              attrs: {
                type: "email",
                placeholder: _vm.$t("contactForm.email"),
                name: "email",
              },
              domProps: { value: _vm.form.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "email", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          !_vm.$v.form.email.required && _vm.$v.form.email.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.emailRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.form.email.email && _vm.$v.form.email.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.emailValidRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subWrapper" }, [
        _c("div", { staticClass: "form__field form__field-text" }, [
          _vm.form.address
            ? _c("label", { attrs: { for: "address" } }, [
                _vm._v(_vm._s(_vm.$t("contactForm.address"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.address,
                expression: "form.address",
              },
            ],
            attrs: {
              type: "text",
              placeholder: _vm.$t("contactForm.address"),
              name: "address",
            },
            domProps: { value: _vm.form.address },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "address", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        !_vm.$v.form.address.required && _vm.$v.form.address.$dirty
          ? _c("p", { staticClass: "error-alert" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("contactForm.error.addressRequired")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.$v.form.address.forbiddenCharacters && _vm.$v.form.address.$dirty
          ? _c("p", { staticClass: "error-alert" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("contactForm.error.addressValidRequired")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper subWrapper" }, [
        _c("div", [
          _c("div", { staticClass: "form__field form__field-text" }, [
            _vm.form.postalCode
              ? _c("label", { attrs: { for: "postalCode" } }, [
                  _vm._v(_vm._s(_vm.$t("contactForm.zipCode"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.postalCode,
                  expression: "form.postalCode",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("contactForm.zipCode"),
                name: "postalCode",
              },
              domProps: { value: _vm.form.postalCode },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "postalCode", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          !_vm.$v.form.postalCode.required && _vm.$v.form.postalCode.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.zipCodeRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          (!_vm.$v.form.postalCode.forbiddenCharacters ||
            !_vm.$v.form.postalCode.minLength ||
            !_vm.$v.form.postalCode.maxLength) &&
          _vm.$v.form.postalCode.$dirty
            ? _c("p", { staticClass: "error" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.zipCodeInvalid")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "form__field form__field-text" }, [
            _vm.form.city
              ? _c("label", { attrs: { for: "city" } }, [
                  _vm._v(_vm._s(_vm.$t("contactForm.city"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.city,
                  expression: "form.city",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("contactForm.city"),
                name: "city",
              },
              domProps: { value: _vm.form.city },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "city", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          !_vm.$v.form.city.required && _vm.$v.form.city.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.cityRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.form.city.forbiddenCharactersAndDigit &&
          _vm.$v.form.city.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.cityValidRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "form__field form__field-text" }, [
            _vm.form.mobilePhone
              ? _c("label", { attrs: { for: "phone" } }, [
                  _vm._v(_vm._s(_vm.$t("contactForm.mobile"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.mobilePhone,
                  expression: "form.mobilePhone",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("contactForm.mobile"),
                name: "phone",
              },
              domProps: { value: _vm.form.mobilePhone },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "mobilePhone", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          !_vm.$v.form.mobilePhone.required && _vm.$v.form.mobilePhone.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.phoneRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.form.mobilePhone.phoneRegex && _vm.$v.form.mobilePhone.$dirty
            ? _c("p", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.phoneValidRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          (!_vm.$v.form.mobilePhone.minLength ||
            !_vm.$v.form.mobilePhone.maxLength) &&
          _vm.$v.form.mobilePhone.phoneRegex &&
          _vm.$v.form.mobilePhone.$dirty
            ? _c("p", { staticClass: "error" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.error.phoneValidRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "project form__field" }, [
        _c("p", { staticClass: "project__title" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("contactForm.project")) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form__field-radio" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.projectType,
                expression: "form.projectType",
              },
            ],
            attrs: {
              id: "live",
              type: "radio",
              value: "Inhabitant",
              name: "projectType",
            },
            domProps: { checked: _vm._q(_vm.form.projectType, "Inhabitant") },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.form, "projectType", "Inhabitant")
              },
            },
          }),
          _vm._v(" "),
          _c("label", { staticClass: "label__live", attrs: { for: "live" } }, [
            _vm._v(_vm._s(_vm.$t("contactForm.live")) + " "),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.projectType,
                expression: "form.projectType",
              },
            ],
            attrs: {
              id: "invest",
              type: "radio",
              value: "Investor",
              name: "projectType",
            },
            domProps: { checked: _vm._q(_vm.form.projectType, "Investor") },
            on: {
              change: function ($event) {
                return _vm.$set(_vm.form, "projectType", "Investor")
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "label__invest", attrs: { for: "invest" } },
            [_vm._v(_vm._s(_vm.$t("contactForm.invest")))]
          ),
        ]),
        _vm._v(" "),
        !_vm.$v.form.projectType.required && _vm.$v.form.projectType.$dirty
          ? _c("p", { staticClass: "error-alert" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("contactForm.error.required")) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.formType === "appointment"
        ? _c("div", { staticClass: "location form__field" }, [
            _c("p", { staticClass: "location__title" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("contactForm.location")) + "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__field-location" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.location,
                    expression: "form.location",
                  },
                ],
                attrs: {
                  id: "phone",
                  type: "radio",
                  value: "phone",
                  name: "location",
                },
                domProps: { checked: _vm._q(_vm.form.location, "phone") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form, "location", "phone")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "phone" } }, [
                _vm._v(_vm._s(_vm.$t("contactForm.phone")) + " "),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.location,
                    expression: "form.location",
                  },
                ],
                attrs: {
                  id: "visio",
                  type: "radio",
                  value: "visio",
                  name: "location",
                },
                domProps: { checked: _vm._q(_vm.form.location, "visio") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form, "location", "visio")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "visio" } }, [
                _vm._v(_vm._s(_vm.$t("contactForm.visio"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.location,
                    expression: "form.location",
                  },
                ],
                attrs: {
                  id: "home",
                  type: "radio",
                  value: "home",
                  name: "location",
                },
                domProps: { checked: _vm._q(_vm.form.location, "home") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form, "location", "home")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "home" } }, [
                _vm._v(_vm._s(_vm.$t("contactForm.home"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.location,
                    expression: "form.location",
                  },
                ],
                attrs: {
                  id: "office",
                  type: "radio",
                  value: "office",
                  name: "location",
                },
                domProps: { checked: _vm._q(_vm.form.location, "office") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form, "location", "office")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "office" } }, [
                _vm._v(_vm._s(_vm.$t("contactForm.office"))),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "terms" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.optin,
              expression: "form.optin",
            },
          ],
          attrs: { id: "", type: "checkbox", name: "terms" },
          domProps: {
            checked: Array.isArray(_vm.form.optin)
              ? _vm._i(_vm.form.optin, null) > -1
              : _vm.form.optin,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.form.optin,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.form, "optin", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.form,
                      "optin",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.form, "optin", $$c)
              }
            },
          },
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: "terms" } }, [
          _vm._v(_vm._s(_vm.$t("contactForm.terms")) + " "),
          _c(
            "a",
            {
              attrs: {
                href: _vm.PRIVACY_POLICY_LINK,
                target: "_blank",
                rel: "noopener",
              },
            },
            [_vm._v(_vm._s(_vm.$t("contactForm.privacyPolicy")) + ".")]
          ),
        ]),
      ]),
      _vm._v(" "),
      !_vm.$v.form.optin.checked && _vm.$v.form.optin.$dirty
        ? _c("p", { staticClass: "error-alert" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("contactForm.error.required")) + "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "validation" }, [
        _c("section", { staticClass: "captcha" }, [
          _c("div", [
            _c("label", [
              _vm._v(
                _vm._s(_vm.captcha.randomNbr1) +
                  " + " +
                  _vm._s(_vm.captcha.randomNbr2) +
                  " = "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.captcha.result,
                  expression: "captcha.result",
                },
              ],
              staticClass: "captcha__result",
              attrs: { type: "text" },
              domProps: { value: _vm.captcha.result },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.captcha, "result", $event.target.value)
                },
              },
            }),
            _vm._v(" ?\n      "),
          ]),
          _vm._v(" "),
          !_vm.$v.captcha.result.required && _vm.$v.form.mobilePhone.$dirty
            ? _c("div", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.captchaRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.captcha.result.numeric && _vm.$v.form.mobilePhone.$dirty
            ? _c("div", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.captchaValidRequired")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.captcha.error === true
            ? _c("div", { staticClass: "error-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contactForm.captchaFalse")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.status !== "PENDING"
          ? _c("button", { staticClass: "cta", attrs: { type: "submit" } }, [
              _vm._v("\n      " + _vm._s(_vm.$t("contactForm.cta")) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status === "PENDING"
          ? _c("p", { staticClass: "cta cta-alert--inprogress" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("contactForm.sending")) + "\n    "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.status === "ERROR"
        ? _c("p", { staticClass: "error-alert--center" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("contactForm.error.global")) + "\n  "
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }